module.exports = __webpack_public_path__ + "static/media/color-line.a08ee5f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/FO/resources/img/color-line.jpg
// module id = 1176
// module chunks = 0